import React, {useState, useContext} from 'react';
import {Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Grid, MenuItem, Backdrop, CircularProgress, DialogContentText} from '@mui/material';
import { TableCell, TableRow} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { TokenContext } from '../App';
import { API } from '../conf';


export default function UserRow(props) {
    const usr = props.user
    const [token, setToken] = useContext(TokenContext)
    const [sending, setSend] = useState(false)
    const [show, setShow] = useState(false)
    const [departements, setDepartmt] = useState([])
    const [nom , setNom] = useState(props.user.nom)
    const [prenom , setPrenom] = useState(props.user.prenom)
    const [mail , setMail] = useState(props.user.mail)
    const [departement , setDept] = useState(props.user.departement)
    const [selectMode, setSelect] = useState(true)
    const [msg, setMsg] = useState()
    const [deleting, setDelete] = useState(false)

    const rm_token =()=>{
        setToken()
        return null
    }

    function get_departements() {
        return new Promise((resolve, reject) => {
            fetch(API.concat('/departements'), {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
            })
            .then(response=> response.status === 200 ? response.json() : null)
            .then(json => resolve(json))  
        })
    }

    function reset_add_form() {
        setShow(false)
        setSelect(true)
    }

    function update() {
        if(nom&& prenom&& mail){
            setSend(true)
            setMsg()
            fetch(API.concat(`/utilisateur/${usr._id}/update`), {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify({
                    nom: nom,
                    prenom: prenom,
                    mail: mail,
                    departement: departement
                })
            })
            .then(response=> {
                if(response.status === 200){
                    console.log('it"s ok');
                    var new_usr = props.user
                    new_usr.nom = nom; new_usr.prenom = prenom; new_usr.mail = mail; new_usr.departement = departement
                    props.update_data[0](usr, new_usr)
                    reset_add_form();
                } else setMsg('**Une erreur est survenue, veuillez réessayer ultérieurement')
                setSend(false)
            })
        } else setMsg('**Vous devez remplir tous les champs obligatoires')
    }

    function handleDeleteSubmit() {
        setSend(true)
        fetch(API.concat(`/utilisateur/${usr._id}`), {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
        .then(response=> {
            if(response.status === 200){
                props.update_data[1](usr)
            } else if(response.status === 401) rm_token() 
            setDelete(false);
            setSend(false)
        })
    }

    return(
        <>
        <TableRow
        key={usr._id}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
        >
            <TableCell align='center' ><span style={{textTransform: 'capitalize'}}>{usr.nom}</span></TableCell>
            <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{usr.prenom}</span></TableCell>
            <TableCell align="center"><span style={{textTransform: 'capitalize'}}>{usr.departement}</span></TableCell>
            <TableCell align="center">
                <Button variant='text' style={{color:'turquoise', marginRight:20, textDecorationLine:'underline', textTransform:'none', height: 18}}
                onClick={()=>{
                    setShow(true)
                    get_departements().then(json=> {if(json !== null) setDepartmt(json.concat(['pasteur', 'nouveau département']))})
                }}>Modifier</Button>
                <Button variant='text' style={{color:'coral', textDecorationLine:'underline', textTransform:'none', height: 18}}
                onClick={()=> setDelete(true)}>Supprimer</Button>
            </TableCell>
        </TableRow>
        {/*update dialog */}
        <Dialog open={show} onClose={()=> reset_add_form()} sx={{borderRadius:5}} >
            <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold'}}>Modifier</DialogTitle>
            <DialogContent>
                <DialogContentText><span style={{color: 'coral', fontSize:13}}>{msg}</span></DialogContentText>
                <Grid container spacing={{xs: 3, md: 5}}>
                    <Grid item>
                    <TextField
                    margin="normal"
                    required
                    id="nom"
                    label="Nom"
                    name="nom"
                    autoComplete="family-name"
                    autoFocus
                    value={nom}
                    onChange={(event)=> setNom(event.target.value)}
                    />
                    </Grid>
                    <Grid item>
                    <TextField
                    margin="normal"
                    required
                    label="Prénom"
                    name="prenom"
                    autoComplete="given-name"
                    value={prenom}
                    onChange={(event)=> setPrenom(event.target.value)}
                    />
                    </Grid>
                </Grid>
                <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Adresse mail"
                name="email"
                autoComplete="email"
                value={mail}
                onChange={(event)=> setMail(event.target.value)}
                />
                <TextField
                id="outlined-select-currency"
                select={selectMode}
                fullWidth
                style={{marginTop: 16}}
                label="Département"
                value={departement}
                onChange={(e)=> e.target.value === 'nouveau département' ? setDept('') : setDept(e.target.value)}
                >
                {departements.map((option) => (
                    <MenuItem key={option} value={option} style={option === 'nouveau département' ?{ justifyContent: 'center', borderWidth:1, borderColor:"grey"} : {}}>
                        {option === 'nouveau département' ?
                        <Button variant='outlined' color='purple' onClick={()=> setSelect(false)}>
                            <AddIcon color='purple'/> 
                            <span style={{textTransform: 'capitalize', color: 'purple', fontSize:16}}>{option}</span>
                        </Button> :
                        <span style={{textTransform: 'capitalize'}}>{option}</span> }
                    </MenuItem>
                ))}
                </TextField>
            </DialogContent>
            <DialogActions sx={{justifyContent:'center', marginBottom: 2}}>
                <Button variant='contained' color='grey' onClick={()=> reset_add_form()}><span style={{ fontWeight:'bold'}}>Annuler</span></Button>
                <Button variant='contained' color='valide' 
                onClick={update}><span style={{color:'#000', fontWeight:'bold'}} disabled={sending || !nom||!prenom||!mail}>Enregistrer</span></Button>
            </DialogActions>
            <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={sending}
            >
                <CircularProgress color="valide" />
            </Backdrop>
        </Dialog>
        {/* delete dialog */}
        <Dialog open={ deleting } onClose={()=> {setDelete()}} sx={{borderRadius:5}} >
            <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold'}}><span style={{color: 'coral', fontStyle:'italic'}}>Supprimer </span> {nom} {prenom}</DialogTitle>
            <DialogContent>
                <DialogContentText><span style={{color: '#EF7070', fontSize:13}}>{msg}</span></DialogContentText>
                <DialogContentText sx={{textAlign: 'center'}}><span style={{ color:'#000'}}>Cette opération est irréversible et supprimera toutes les données de l'employé.<br/> Êtes-vous sûr de vouloir continuer ?</span></DialogContentText>
            </DialogContent>
            <DialogActions sx={{justifyContent:'center', marginBottom: 2}}>
                <Button variant='contained' color='grey' onClick={()=> {setDelete()}}><span style={{ fontWeight:'bold'}}>Annuler</span></Button>
                <Button variant='contained' color='coral' 
                onClick={handleDeleteSubmit}><span style={{color:'#000', fontWeight:'bold'}}>Supprimer</span></Button>
            </DialogActions>
            <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={sending && deleting }
            >
                <CircularProgress color="coral" />
            </Backdrop>
        </Dialog>
        </>
    )
}